module.exports = __webpack_public_path__ + "static/img/bcr-icoc.9c5b4edb.gif";